<template>

  <!-- Created (CREATED) -->
  <route-list-data-table
      title="Created"
      defaultSortField="created_at"
      defaultSortOrder="dsc"
      :headers="headers"
      :status="status"
      :assocs="assocs"
      routeClickGoTo="route-builder" />

</template>

<script>
import RouteListDataTable from '@/components/routes/RouteListDataTable'

export default {
  name: 'RouteListCreatedPage',

  components: {
    RouteListDataTable
  },

  data () {
    return {
      headers: [
        { text: 'Name', align: 'start', value: 'name', width: '18%' },
        { text: 'Orders', sortable: false, value: 'orders', width: '180px' },
        { text: 'Delivery Date', value: 'delivery_date' },
        { text: 'Start At', value: 'scheduled_start_time' },
        { text: 'Est. Return', value: 'estimated_return_time' },
        { text: 'Vehicle', value: 'vehicle_id' },
        { text: 'Driver', value: 'driver_user_id' },
        { text: 'Created', value: 'created_at' },
        { text: 'Status', align: 'start', value: 'route_status' }
      ],
      status: ['CREATED'],
      assocs: 'orders,driver,vehicle'
    }
  }
}
</script>

<style scoped>
</style>
